<template>
  <router-view/>
</template>

<script>
import Gifffer from 'gifffer'; // 动态图可以暂停和播放
export default {
  methods: {
    fontSizeAuto () {
      var viewportWidth = document.documentElement.clientWidth;
      if (viewportWidth > 640) { viewportWidth = 640 }
      if (viewportWidth < 320) { viewportWidth = 320 }
      document.documentElement.style.fontSize = viewportWidth / 23 + 'px';
    },
  },
  mounted () {
    this.fontSizeAuto();
    setTimeout(() => {
      Gifffer();
    }, 2000);
    // 页面访问上报
    this.$pushData("website_pageview_leave_information");
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>